import React from 'react';
import Copyright from './Copyright';
import '../../sass/components/_footer.scss';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   valid: {
    //     name: false,
    //     email: false,
    //     message: false,
    //   },
    // };
  }

  // validateMail(mail) {
  //   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   return re.test(String(mail).toLowerCase());
  // }

  // validate(element) {
  //   let isValid = false;
  //   const validState = this.state.valid;

  //   if (element.target.value.length > 0) {
  //     if (element.target.name === 'email' && !this.validateMail(element.target.value)) {
  //       isValid = false;
  //     } else {
  //       isValid = true;
  //     }
  //   }

  //   if (isValid) {
  //     element.target.className = 'valid';
  //     validState[element.target.name] = true;
  //   } else {
  //     element.target.className = 'invalid';
  //     validState[element.target.name] = false;
  //   }
  //   this.setState({ valid: validState });
  //   if (this.state.valid.name && this.state.valid.email && this.state.valid.message) {
  //     document.getElementById('form-submit').className = 'valid';
  //     document.getElementById('form-submit').disabled = false;
  //   } else {
  //     document.getElementById('form-submit').className = 'invalid';
  //     document.getElementById('form-submit').disabled = true;
  //   }
  // }

  render() {
    return (
      <footer className="footer">
        <h2>contact</h2>
        <form
          action="/?no-cache=1"
          id="contact"
          name="contact-form"
          data-netlify="true"
          netlify-honeypot="bot-field"
          method="POST"
        >
          <input name="bot-field" className="visually-hidden" />
          <label className="name-field">
            Name
            <input
              // onChange={(e) => this.validate(e)}
              type="text"
              name="name"
              required
            />
          </label>
          <label className="mail-field">
            Email
            <input
              // onChange={(e) => this.validate(e)}
              type="email"
              name="email"
              required
            />
          </label>
          <label className="message-field">
            Message
            <textarea
              // onChange={(e) => this.validate(e)}
              name="message"
              required
            />
          </label>
          <button type="submit" id="form-submit">
            Send
          </button>
        </form>
        <Copyright />
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js